import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RouteKeys } from '../helper/route-keys.helper';
import { ApiService } from './api.service';
import { StorageService } from './storage.service';
import { alert } from 'devextreme/ui/dialog';

@Injectable()
export class ConfigExternService {
  public globalSettings: any[] = [];
  noConfigFoundWarning: string[] = [];
  isInit: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private apiService: ApiService, private storageService: StorageService) {}

  init(): Observable<boolean> {
    this.load();
    this.checkVersion();
    return this.isInit.asObservable();
  }

  stop() {
    this.isInit.next(false);
  }

  reload() {
    this.load();
  }

  private load() {
    this.apiService.post<any>(RouteKeys.Config.get_config_extern, null).subscribe((response) => {
      this.noConfigFoundWarning = [];
      this.globalSettings = response.globalSettings;
      this.isInit.next(true);
    });
  }

  private checkVersion() {
    this.apiService.post<any>(RouteKeys.Config.get_version, null).subscribe((response) => {
      const actuellVersion = response.version;
      const lastVersion = this.storageService.getFromLocale('lastVersion');

      if (lastVersion === null || lastVersion === undefined || lastVersion !== actuellVersion) {
        const url = new URL(window.location.href);
        url.searchParams.set('nocache', Date.now().toString());
        window.location.href = url.toString();
        this.storageService.saveToLocale('lastVersion', actuellVersion);
      }
    });
  }

  public getGlobalSetting(param: string): string {
    if (param !== '' && param !== undefined) {
      const result = this.globalSettings.find((x) => x.key === param);
      if (result != null && result !== undefined) {
        return result.value;
      }
    }
    return '';
  }
}
